import { formatBytes, KIND_LABELS, type AttachedDocument } from '../lib/documents'

interface AttachmentTrayProps {
  documents: AttachedDocument[]
  parsing: string[]
  onRemove: (id: string) => void
}

export function AttachmentTray({ documents, parsing, onRemove }: AttachmentTrayProps) {
  if (documents.length === 0 && parsing.length === 0) return null

  return (
    <ul className="attachments" aria-label="Attached documents">
      {documents.map((doc) => (
        <li key={doc.id} className="attachment">
          <FileIcon kind={doc.kind} />
          <span className="attachment__name" title={doc.path}>
            {doc.name}
          </span>
          <span className="attachment__meta" title={doc.warning}>
            {doc.warning ? 'basic text' : formatBytes(doc.bytes)}
          </span>
          <button
            type="button"
            className="attachment__remove"
            onClick={() => onRemove(doc.id)}
            aria-label={`Remove ${doc.name}`}
          >
            <CloseIcon />
          </button>
        </li>
      ))}

      {parsing.map((name) => (
        <li key={`parsing-${name}`} className="attachment attachment--pending">
          <span className="spinner spinner--sm" aria-hidden />
          <span className="attachment__name" title={name}>
            {name}
          </span>
          <span className="attachment__meta">Reading…</span>
        </li>
      ))}
    </ul>
  )
}

function FileIcon({ kind }: { kind: AttachedDocument['kind'] }) {
  return (
    <span className={`attachment__badge attachment__badge--${kind}`} aria-hidden>
      {KIND_LABELS[kind]}
    </span>
  )
}

function CloseIcon() {
  return (
    <svg viewBox="0 0 24 24" width="14" height="14" aria-hidden focusable="false">
      <path
        d="M19 6.4 17.6 5 12 10.6 6.4 5 5 6.4 10.6 12 5 17.6 6.4 19 12 13.4 17.6 19 19 17.6 13.4 12z"
        fill="currentColor"
      />
    </svg>
  )
}
